import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import kebabCase from "lodash/kebabCase";

import '../styles/index.css';

export default function Index({ data }) {
  const { edges: posts } = data.allMarkdownRemark;
  return (
    <div className="blog-posts">
      {posts
        .filter(post => post.node.frontmatter.title.length > 0)
        .map(({ node: post }) => {
          const { tags } = post.frontmatter;
          return (
            <div className="blog-post" key={post.id}>
              <img style={{ paddingTop: '1rem', }} src={post.frontmatter.thumbnail.childImageSharp.resize.src} />
              <div className='blog-preview'>
                <h2 style={{ marginTop: '1rem', marginBottom: '0.75rem', }}>
                  <Link
                    style={{ color: 'slategrey', }}
                    to={post.frontmatter.path}>{post.frontmatter.title}</Link>
                </h2>
                <div className='blog-metadata'>
                  <h3 className='blog-date'>{post.frontmatter.date}</h3>
                  <p className='blog-tags'>[{tags.map((tag, index) =>
                    <i>
                      <Link style={{ color: 'darkslategrey', }}
                        to={`/tags/${kebabCase(tag)}/`}>{tag}</Link>
                      {tags.length > 1 && index !== tags.length - 1 ? ', ' : ''}
                    </i>)}]
                </p>
                </div>
                <p>{post.excerpt}</p>
              </div>
            </div>
          );
        })}
    </div>
  );
}

export const pageQuery = graphql`
  query IndexQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          excerpt(pruneLength: 250)
          id
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
            tags
            thumbnail {
              childImageSharp {
                resize(width: 200, height: 200){
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/pages/index.js